import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  Box,
  Breadcrumbs,
  Link,
  Typography,
} from "@mui/material";
import dayjs from "dayjs";
import { ZatcaTransactionDetailApi } from "./Action";
import { DataGridPro, useGridApiRef  } from "@mui/x-data-grid-pro";
import { createMultiSelectOperator } from "../../Component/Common/ReuseableComponent/DatagridFilterColumnComp";
import { fAlertToast } from "../../Utility/Utilitys";

// Utility function to extract unique, non-empty values
const getUniqueValues = (data, key) => {
  return [
    ...new Set(
      (data ?? [])
        .map((item) => item[key])
        .filter((val) => val !== "" && val !== undefined && val !== null)
    ),
  ];
};

const ZatcaTransactionDetail = () => {
  const navigate = useNavigate();
  const apiRef = useGridApiRef();
  const [searchParams] = useSearchParams();
  const key = searchParams.get('key'); 

  const [data, setData] = useState(null);
  const [TransactionDetailData, setTransactionDetailData] = useState([]);

  const locationList = getUniqueValues(TransactionDetailData, "LocName");
  const vocTypeList = getUniqueValues(TransactionDetailData, "VocTypName");
  const posIDList = getUniqueValues(TransactionDetailData, "PosID");
  const invNoList = getUniqueValues(TransactionDetailData, "INVNo");

  const columns = [
    {
    field: "SrNo",
    headerName: "Sr.No",
    width: 30,
    align:"center"
  },
  {
    field: "INV_KEY_ID",
    headerName: "Invoice Key ID",
    width: 130,
    align:"center",
    headerAlign:"center"
  },
  {
    field: "LocName",
    headerName: "Location",
    filterOperators: [createMultiSelectOperator(locationList)],
    width: 200,
  },
  {
    field: "VocTypName",
    headerName: "Voucher Type",
    filterOperators: [createMultiSelectOperator(vocTypeList)],
    width: 200,
  },
  {
    field: "Vocno",
    headerName: "Voucher No",
    width: 110,
  },
  {
    field: "PosID",
    headerName: "POS ID",
    width: 70,
    filterOperators: [createMultiSelectOperator(posIDList)],
    align: "center",
  },
  {
    field: "INVNo",
    headerName: "Invoice No",
    width: 90,
    filterOperators: [createMultiSelectOperator(invNoList)],
    align: "center",
  },
    {
    field: "InvoiceType",
    headerName: "Invoice Type",
    width: 100,
  },
    {
    field: "DATE_NDX",
    headerName: "Date",
    width: 90,
    align:"center",
    headerAlign:"center",
    valueFormatter: (params) => dayjs(params.value).format("DD-MM-YYYY"), 
  },
  {
    field: "PostDt",
    headerName: "Post Date",
    width: 90,
    align:"center",
    headerAlign:"center",
    valueFormatter: (params) => dayjs(params.value).format("DD-MM-YYYY"), 
  },
  {
    field: "isClearanceSucces",
    headerName: "Clearance",
    width: 90,
    align: "center",
  },
  {
    field: "isReportingSucces",
    headerName: "Reporting",
    width: 90,
    align: "center",
  },
];

    useEffect(() => {
      const fetchTransactionDetail = async () => {
        try {
          if (data) {
            if(!data?.TransactionType){
              fAlertToast("FAILED","Transaction type is required")
              return;
            }
            const response = await ZatcaTransactionDetailApi({
              StartDate: dayjs(data?.dateFrom).format("MM-DD-YYYY"),
              EndDate: dayjs(data?.dateTo).format("MM-DD-YYYY"),
              LocUIds: data?.selectedLocations?.map((el) => el.Uid).join(","),
              TransType: data?.TransactionType,
            });
            if (response?.data)
              setTransactionDetailData(response?.data?.data || []);
          }
        } catch (error) {
          console.error("Error fetching transaction details:", error);
        }
      };
      fetchTransactionDetail();
    }, [data]);

    useEffect(() => {
      const raw = localStorage.getItem(key);
      if (raw) {
        setData(JSON.parse(raw));
      }
    }, [searchParams]);

    useEffect(() => {
      return () => {
        localStorage.removeItem(key);
      };
    }, []);


  return (
    <>
      {/* Breadcrumbs */}
      <Breadcrumbs
        aria-label="breadcrumb"
        sx={{ marginTop: 3, marginBottom: 1.5 }}
      >
        <Link
          underline="hover"
          color="inherit"
          onClick={() => navigate("/ZatcaTransactionSummary")}
          style={{ cursor: "pointer" }}
        >
          Zatca Transaction Summary
        </Link>
        <Typography color="text.dark" typography={"commonText"}>
          {data?.TransactionTypeName || "Transaction Details"}
        </Typography>
      </Breadcrumbs>
      <Box sx={{ width: "100%", height: "85vh", overflow: "auto" }}>
        <DataGridPro
          rows={TransactionDetailData ?? []}
          columns={columns}
          apiRef={apiRef}
          headerHeight={40}
          rowHeight={30}
          getRowId={(row) => row?.SrNo}
          hideFooter
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0
              ? "mui-even-row"
              : "mui-odd-row"
          }
          sx={{
            border: 1,
            borderColor: "primary.light",
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "#0d73bb",
              color: "white",
            },
          }}
        />
      </Box>
    </>
  );
};

export default ZatcaTransactionDetail;
